export enum DOCUMENT_FILE_TYPE {
  SPREAD_SHEET = 'Spreadsheet',
  TERM_SHEET = 'Term Sheet',
  KID = 'KIDs',
  FINAL_TERMS = 'Final Terms',
  OTHER = 'Other',
}

export enum DocumentSubType {
  TMG = 'TMG',
  TMG_TREASURY = 'TMG_TREASURY',
}
